import isUndefinedNullOrEmpty from '@ahd/shared/tools/is-undefined-null-or-empty';

import { type Theme } from '@mui/material/styles';

import { type ConfigObject } from '../../_configs/types';

export default function replaceStyleTexts<T>(
    obj: T,
    variables: {
        captionFontSize: Theme['typography']['caption']['fontSize'];
        colorPrimary: ConfigObject['style']['primaryColor'];
        colorSecondary: ConfigObject['style']['secondaryColor'];
        fontFamily: ConfigObject['style']['fontFamily'];
        fontSize: ConfigObject['style']['fontSize'];
        parentBackgroundColor: Theme['parentBackgroundColor'];
        textPrimary: Theme['palette']['text']['primary'];
    }
): T {
    if (isUndefinedNullOrEmpty(obj)) {
        return obj;
    }

    const newObj = Object.assign({}, obj);
    const keys = Object.keys(newObj);
    keys.map(function (key) {
        const value = newObj[key];
        if (typeof value === 'object') {
            newObj[key] = Object.assign({}, replaceStyleTexts(value, variables));
        } else if (typeof value === 'string') {
            if (value.includes('<fontSize>')) {
                newObj[key] = variables.fontSize;
            }
            newObj[key] = value
                .replace('<captionFontSize>', variables.captionFontSize.toString())
                .replace('<colorPrimary>', variables.colorPrimary)
                .replace('<colorSecondary>', variables.colorSecondary)
                .replace('<textPrimary>', variables.textPrimary)
                .replace('<parentBackgroundColor>', variables.parentBackgroundColor)
                .replace('<fontFamily>', variables.fontFamily);
        } else {
            newObj[key] = value;
        }
    });

    return newObj as T;
}
